import React, { useEffect } from 'react';
import HomeHero from '../../comps/homeHero';
import Header from '../../comps/header'
import Partners from '../../comps/partners'
import { checkLoggedIn } from '../../tools/settings';
import { useCMS } from 'tinacms';
import { usePlugin, useForm } from 'tinacms'
import { InlineForm } from 'react-tinacms-inline'
import useSettings from "../../tools/settings"
import Footer from "../../comps/footer"
import StickyContact from "../../comps/sticky-contact"
function Page() {
    const cms=useCMS();
    useEffect(()=>checkLoggedIn(cms),[cms]);

    const settings = useSettings(["homeHero","partners"])
    // 1. Define the form
    const FormOptions = {
      id:"home",
      loadInitialValues() {
         let data = settings.get();
         console.log(data);
         return(data)
      },
      onSubmit: (content) => settings.save(content)
    }
  
    // 2. Pass the form as the second argument
     const [, form] = useForm(FormOptions)
     // 3. Register the form as a plugin
     usePlugin(form)
    return <>
        <Header />
        <InlineForm form={form}>
        <div class="page">
          <HomeHero groupName="homeHero"/>
          <Partners groupName="partners" />
        </div>
        </InlineForm>
        <StickyContact />
        <Footer />


    </>
}

export default Page;